var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoKia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E3E3E",
    d: "M23.206 23.43c0 .078.024.122.068.122.036-.004.068-.02.096-.04l12.466-8.188c.211-.15.463-.226.72-.219h2.74c.42 0 .704.284.704.708v5.295c0 .639-.14 1.011-.7 1.351l-3.324 2.024c-.033.023-.071.037-.112.04-.04 0-.08-.032-.08-.15v-6.176c0-.072-.02-.121-.068-.121-.035.004-.068.018-.096.04l-9.11 5.99c-.209.142-.453.22-.7.215h-6.04c-.424 0-.704-.283-.704-.712v-7.63c0-.056-.024-.109-.072-.109-.035.005-.068.019-.096.04l-6.011 3.651c-.06.04-.076.07-.076.098 0 .024.012.048.052.093l4.295 4.342c.056.057.096.102.096.15 0 .04-.064.073-.14.073h-3.88c-.303 0-.54-.044-.703-.21l-2.604-2.631c-.02-.024-.049-.039-.08-.04-.028 0-.056.009-.08.024l-4.352 2.647c-.264.161-.444.206-.703.206H.708C.28 24.317 0 24.03 0 23.605v-5.193c0-.644.14-1.012.704-1.352l3.344-2.032c.026-.017.056-.027.088-.028.052 0 .08.053.08.17v6.953c0 .073.016.106.068.106.036-.005.068-.02.1-.04l11.294-6.877c.216-.15.48-.223.744-.21h6.08c.42 0 .704.282.704.707l-.004 7.622h.004z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKia);
export default __webpack_public_path__ + "static/media/logo-kia.c1f75152.svg";
export { ForwardRef as ReactComponent };